import React, { useCallback, useState, useEffect } from 'react'
import { Formik, Form } from 'formik'
import { FaArrowRight } from 'react-icons/fa'
import { FiPlus } from 'react-icons/fi'
import { toast } from 'react-toastify'
import Yup from '~/services/yup'
import { api } from '~/services/api'

import masks from '~/util/masks'
import formUtils from '~/util/form'

import { Textbox, Button, Select } from '~/components/Form'
import ActionFooter from '~/components/ActionFooter'
import Table from '~/components/Table'

import { Container } from './styles'

const initialValuesContato = {
    tipo_contato: { value: '', label: '' },
    valor_contato: ''
}

const initialValuesRedesSociais = {
    tipo_media_social: { value: '', label: '' },
    valor_media_social: ''
}

export default function ({ callback }) {
    const [tipoContato, setTipoContato] = useState([])
    const [redesSociais, setRedesSociais] = useState([])

    const [validacaoContato, setValidacaoContato] = useState(null)
    const [validacaoMediaSocial, setValidacaoMediaSocial] = useState(null)

    const [associadoContatos, setAssociadoContatos] = useState([])
    const [associadoRedesSociais, setAssociadoRedesSociais] = useState([])

    useEffect(() => {
        async function loadMediaSocial() {
            const response = await api.get('/media_social')

            setRedesSociais(response)
        }

        loadMediaSocial()
    }, [])

    useEffect(() => {
        async function loadTipoContato() {
            const response = await api.get('tipo_contato')

            setTipoContato(response)
        }

        loadTipoContato()
    }, [])

    useEffect(() => {
        const storageData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))

        localStorage.setItem('sindmepa-associacao-temp-data', JSON.stringify({
            ...storageData,
            contatos: storageData?.contatos || (
                storageData?.pessoal?.email
                && [
                    {
                        id: 1,
                        tipo_contato: 6,
                        valor_contato: storageData.pessoal.email
                    }
                ]
            )
        }))
    }, [])

    useEffect(() => {
        const storageData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))

        if (!storageData?.contatos) {
            localStorage.setItem('sindmepa-associacao-temp-data', JSON.stringify({
                ...storageData,
                contatos: []
            }))
        }

        if (!storageData?.medias_sociais) {
            localStorage.setItem('sindmepa-associacao-temp-data', JSON.stringify({
                ...storageData,
                medias_sociais: []
            }))
        }

        setAssociadoContatos(storageData?.contatos?.length ? storageData.contatos.map((contato, index) => ({
            id: index,
            valor_contato: contato.valor_contato,
            tipo_contato: tipoContato.length ? tipoContato.find(tipo => tipo.id === contato.tipo_contato).descricao : null
        })) : [])

        setAssociadoRedesSociais(storageData?.medias_sociais?.length ? storageData.medias_sociais.map((media, index) => ({
            id: index,
            valor_media_social: media.valor_media_social,
            tipo_media_social: redesSociais.length ? redesSociais.find(rede => rede.id === media.tipo_media_social).icone : null
        })) : [])
    }, [tipoContato, redesSociais])

    const adicionarContato = useCallback((values, { setSubmitting, resetForm }) => {
        const data = formUtils.extractFormValues(values)

        const storageData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))

        storageData.contatos.push(data)

        localStorage.setItem('sindmepa-associacao-temp-data', JSON.stringify(storageData))

        setSubmitting(false)
        resetForm()

        setAssociadoContatos(storageData.contatos.map((contato, index, arr) => ({
            id: index,
            valor_contato: contato.valor_contato,
            tipo_contato: tipoContato.find(tipo => tipo.id === contato.tipo_contato).descricao,
            highlight: index === arr.length - 1
        })))
    }, [tipoContato])

    const adicionarRedeSocial = useCallback((values, { setSubmitting, resetForm }) => {
        const data = formUtils.extractFormValues(values)

        const storageData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))

        storageData.medias_sociais.push(data)

        localStorage.setItem('sindmepa-associacao-temp-data', JSON.stringify(storageData))

        setSubmitting(false)
        resetForm()

        setAssociadoRedesSociais(storageData.medias_sociais.map((media, index, arr) => ({
            id: index,
            valor_media_social: media.valor_media_social,
            tipo_media_social: redesSociais.find(rede => rede.id === media.tipo_media_social).icone,
            highlight: index === arr.length - 1
        })))
    }, [redesSociais])

    const proximaEtapa = useCallback(() => {
        const storageData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))

        if (!storageData.contatos.find(contato => [1, 2, 3, 4, 5].includes(contato.tipo_contato))) {
            toast.warn('Forneça pelo menos um contato telefônico.')
            return
        }

        if (!storageData.contatos.find(contato => [6].includes(contato.tipo_contato))) {
            toast.warn('Forneça pelo menos um e-mail.')
            return
        }

        toast.success('Dados salvos! Por favor, continue o preenchimento.')

        callback()
    }, [callback])

    const excluirContato = useCallback(async (valor) => {
        setAssociadoContatos(associadoContatos.filter(contato => contato.valor_contato !== valor))

        const storageData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))
        storageData.contatos = storageData.contatos.filter(contato => contato.valor_contato !== valor)

        localStorage.setItem('sindmepa-associacao-temp-data', JSON.stringify(storageData))

        return true
    }, [associadoContatos])

    const excluirRedeSocial = useCallback(async (valor) => {
        setAssociadoRedesSociais(associadoRedesSociais.filter(rede => rede.valor_media_social !== valor))

        const storageData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))
        storageData.medias_sociais = storageData.medias_sociais.filter(media => media.valor_media_social !== valor)
        localStorage.setItem('sindmepa-associacao-temp-data', JSON.stringify(storageData))

        return true
    }, [associadoRedesSociais])

    const getMascaraContato = useCallback(tipo => {
        switch (tipo) {
            case 1: case 2:
                return masks.phone
            case 3: case 4: case 5:
                return masks.mobile
            default:
                return null
        }
    }, [])

    const handleTipoContatoChange = useCallback((selected, setFieldValue) => {
        setFieldValue('tipo_contato', selected)

        const tipoId = selected.value
        let validacaoValorContato

        switch (tipoId) {
            case 1: case 2:
                validacaoValorContato = Yup.string().phone()
                break
            case 3: case 4: case 5:
                validacaoValorContato = Yup.string().mobile()
                break
            case 6:
                validacaoValorContato = Yup.string().email('E-mail inválido.')
                break
            default:
                validacaoValorContato = Yup.string()
        }

        setValidacaoContato(Yup.object({
            tipo_contato: Yup.object({ value: Yup.number(), label: Yup.string() }).required('Selecione um tipo.'),
            valor_contato: validacaoValorContato.concat(Yup.string().required('Defina o valor.'))
        }))
    }, [])

    const handleRedeSocialChange = useCallback((selected, setFieldValue) => {
        setFieldValue('tipo_media_social', selected)

        setValidacaoMediaSocial(Yup.object({
            tipo_media_social: Yup.object({ value: Yup.number(), label: Yup.string() }).required('Selecione uma rede social.'),
            valor_media_social: Yup.string().required('Digite seu perfil.')
        }))
    }, [])

    return (
        <Container>
            <Formik
                initialValues={initialValuesContato}
                validationSchema={validacaoContato}
                onSubmit={adicionarContato}
                enableReinitialize
            >
                {({ isSubmitting, setFieldValue, values }) => (
                    <Form className="contato-form">
                        <h1>Contatos</h1>

                        <Select
                            name="tipo_contato"
                            label="Selecione o tipo de contato"
                            onChange={selected => handleTipoContatoChange(selected, setFieldValue)}
                            options={tipoContato.map(tipo => ({
                                label: tipo.descricao,
                                value: tipo.id
                            }))}
                            isSearchable={false}
                        />

                        <Textbox
                            name="valor_contato"
                            label={values.tipo_contato.value === 6 ? 'Endereço' : 'Número'}
                            mask={getMascaraContato(values.tipo_contato.value)}
                            inputMode={values.tipo_contato.value === 6 ? 'email' : 'numeric'}
                            disabled={!values.tipo_contato.value}
                            style={{ textTransform: values.tipo_contato.value === 6 ? 'lowercase' : 'unset' }}
                        />

                        <Button type="submit" loading={isSubmitting} className="transparent">
                            Adicionar
                            <FiPlus />
                        </Button>

                        <Table
                            headers={[
                                { name: 'valor_contato', value: 'Contato' },
                                { name: 'tipo_contato', value: 'Tipo' }
                            ]}
                            data={associadoContatos}
                            limit={5}
                            filterable={false}
                            handleDelete={excluirContato}
                            keyProp="valor_contato"
                        />
                    </Form>
                )}
            </Formik>

            <Formik
                initialValues={initialValuesRedesSociais}
                validationSchema={validacaoMediaSocial}
                onSubmit={adicionarRedeSocial}
                enableReinitialize
            >
                {({ isSubmitting, setFieldValue, values }) => (
                    <Form className="media-social-form">

                        <h1>Redes sociais</h1>

                        <Select
                            name="tipo_media_social"
                            label="Selecione a rede social"
                            onChange={selected => handleRedeSocialChange(selected, setFieldValue)}
                            options={redesSociais.map(media => ({
                                label: media.nome,
                                value: media.id
                            }))}
                            isSearchable={false}
                        />

                        <Textbox
                            name="valor_media_social"
                            label="Perfil"
                            disabled={!values.tipo_media_social.value}
                        />

                        <Button type="submit" loading={isSubmitting} className="transparent">
                            Adicionar
                            <FiPlus />
                        </Button>

                        <Table
                            headers={[
                                { name: 'valor_media_social', value: 'Perfil' },
                                { name: 'tipo_media_social', value: 'Media social', icon: true }
                            ]}
                            data={associadoRedesSociais}
                            limit={5}
                            filterable={false}
                            handleDelete={excluirRedeSocial}
                            keyProp="valor_media_social"
                        />
                    </Form>
                )}
            </Formik>

            <ActionFooter>
                <Button onClick={proximaEtapa} className="white">
                    Continuar
                    <FaArrowRight />
                </Button>
            </ActionFooter>

        </Container>
    )
}
